export const performanceReviewConverter = {
    toFirestore(review) {
        const { id, ...data } = review;
        return {
            ...data,
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        const comments = data?.comments || [];
        const weeklyGoals = data?.weeklyGoals || [];
        return {
            id: snapshot.id,
            userId: data?.userId || snapshot.id,
            comments: Array.isArray(comments)
                ? comments.map((comment) => ({
                    id: comment.id || `${Date.now()}-${Math.random()}`,
                    text: comment.text || '',
                    createdBy: comment.createdBy || '',
                    createdAt: comment.createdAt || new Date().toISOString(),
                }))
                : [],
            weeklyGoals: Array.isArray(weeklyGoals)
                ? weeklyGoals.map((wg) => ({
                    week: wg.week || '',
                    goals: Array.isArray(wg.goals)
                        ? wg.goals.map((goal) => ({
                            id: goal.id || `${Date.now()}-${Math.random()}`,
                            title: goal.title || '',
                            description: goal.description || '',
                            priority: goal.priority || 'medium',
                            status: goal.status || 'not_started',
                            dueDate: goal.dueDate || new Date().toISOString(),
                            createdAt: goal.createdAt || new Date().toISOString(),
                            updatedAt: goal.updatedAt || new Date().toISOString(),
                        }))
                        : [],
                    updatedAt: wg.updatedAt || new Date().toISOString(),
                }))
                : [],
            createdAt: data?.createdAt || (comments.length > 0 ? comments[0]?.createdAt : new Date().toISOString()),
            updatedAt: data?.updatedAt || (comments.length > 0 ? comments[comments.length - 1]?.createdAt : new Date().toISOString()),
            month: data?.month,
            year: data?.year,
        };
    },
};
